import React, { useEffect, useState, useCallback } from 'react';
import Modal from 'Components/Modal/Modal';
import BlueSearchIcon from 'Assets/SVG/bluesearchicon.svg';
import ExplorIcon from 'Assets/SVG/exploricon.svg';
import { Link, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import axiosInstance from 'Utils/Interceptor';
import { toast } from 'react-toastify';
import { slugify } from 'Utils/Functions';

function SearchModal({ handleCloseModal, show }) {
  let { cityId, cityName } = useSelector((state) => state.location);
  const [value, setVlaue] = useState('');
  const [searchList, setSearchList] = useState(null);
  const [limit, setLimit] = useState(20);
  const [searchData, setSearchData] = useState([]);
  const [userSearchList, setUserSearchList] = useState(null);
  const navigate = useNavigate();
  cityName = slugify(cityName);

  const handleKeyPress = (event) => {
    if (searchData.length > 0) {
      if (event.key === 'Enter') {
        navigate(`/search/${value}`);
      }
    }
  };

  const fetchSearchData = async (url, setter, params, flag) => {
    try {
      const { data } = await axiosInstance.get(url, { params });
      console.log({ data });
      setter(data);
      setSearchData(data?.data);
      if (params.query && data.data.length === 0) {
        toast.error(
          'No data found. Please clear your search input and retype.',
          {}
        );
        console.log('params-length', params.query.length);
        setLimit(params.query.length);
      } else {
        setLimit(20);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const debouncedSearch = useCallback(
    _.debounce((searchValue) => {
      fetchSearchData(
        '/api/user/search',
        setUserSearchList,
        {
          query: searchValue,
          city_id: cityId
        },
        true
      );
    }, 1000),
    [cityId] // Ensure this callback is updated when `cityId` changes
  );

  useEffect(() => {
    if (show) {
      fetchSearchData('/api/user/searchlists', setSearchList, {
        city_id: cityId
      });
    }
  }, [cityId, show]);

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setVlaue(searchValue); // Update local state with the value
    debouncedSearch(searchValue); // Trigger debounced search function
  };

  return (
    <div>
      <Modal
        onClose={handleCloseModal}
        show={show}
        size="full"
      >
        <div className="fixed-search-overlay">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-12">
                <div className="fixed-search-content">
                  <h2>Search</h2>
                  <p>for packages & blood tests</p>

                  <div className="fixed-search-input">
                    <input
                      maxLength={limit}
                      onChange={handleSearch}
                      onKeyPress={handleKeyPress}
                      value={value}
                      className=""
                      type={'text'}
                    />
                    <img
                      src={BlueSearchIcon}
                      alt=""
                      className="fixed-search-icon"
                    />
                  </div>

                  {value ? (
                    <div className="autocomplete-search">
                      {userSearchList?.data.length === 0 && (
                        <p
                          className="text-center"
                          style={{ fontWeight: 'bold' }}
                        >
                          No Data Found
                        </p>
                      )}
                      {userSearchList?.data.map((e) => (
                        <Link
                          to={
                            !e?.is_package
                              ? `/${cityName}/blood-tests/${e?.service_slug}`
                              : `/${cityName}/health-packages/${e?.service_slug}`
                          }
                          className="autocomplete-item"
                        >
                          <div className="autocomplete-text">
                            <h5>{e?.service_name}</h5>
                            <p>{e?.no_of_test_include} {e?.no_of_test_include > 1 ? 'Parameters' : 'Parameter'}</p>
                          </div>
                          <div className="autocomplete-icon">
                            <img
                              className=""
                              src={ExplorIcon}
                              alt=""
                            />
                          </div>
                        </Link>
                      ))}
                    </div>
                  ) : (
                    <>
                      <div className="fixed-search-inner-content">
                        {searchList?.data?.total_search[0] && (
                          <div className="fixed-search-ind-item">
                            <h5>Top Search</h5>
                            {searchList?.data?.total_search?.map((e) => (
                              <Link
                                to={
                                  !e?.is_package
                                    ? `/${cityName}/blood-tests/${e?.service_slug}`
                                    : `/${cityName}/health-packages/${e?.service_slug}`
                                }
                                className="search-list-item"
                              >
                                <div className="search-list-text">
                                  {e?.name}
                                </div>
                                <img
                                  className=""
                                  src={ExplorIcon}
                                  alt=""
                                />
                              </Link>
                            ))}
                          </div>
                        )}

                        {searchList?.data?.popular_packages[0] && (
                          <div className="fixed-search-ind-item">
                            <h5>Popular Health Packages</h5>
                            {searchList?.data?.popular_packages?.map((e) => (
                              <Link
                                to={`/${cityName}/health-packages/${e?.service_slug}`}
                                className="search-list-item"
                              >
                                <div className="search-list-text">
                                  {e?.name}
                                </div>
                                <img
                                  className=""
                                  src={ExplorIcon}
                                  alt=""
                                />
                              </Link>
                            ))}
                          </div>
                        )}

                        {searchList?.data.popular_labtests[0] && (
                          <div className="fixed-search-ind-item">
                            <h5>Popular Tests</h5>
                            {searchList?.data?.popular_labtests?.map((e) => (
                              <Link
                                to={`/${cityName}/blood-tests/${e?.service_slug}`}
                                className="search-list-item"
                              >
                                <div className="search-list-text">
                                  {e?.name}
                                </div>
                                <img
                                  className=""
                                  src={ExplorIcon}
                                  alt=""
                                />
                              </Link>
                            ))}
                          </div>
                        )}

                        {searchList?.data?.previously_booked[0] && (
                          <div className="fixed-search-ind-item">
                            <h5>Previously Booked</h5>
                            {searchList?.data?.previously_booked?.map((e) => (
                              <Link
                                to={
                                  !e?.is_package
                                    ? `/${cityName}/blood-tests/${e?.service_slug}`
                                    : `/${cityName}/health-packages/${e?.service_slug}`
                                }
                                className="search-list-item"
                              >
                                <div className="search-list-text">
                                  {e?.name}
                                </div>
                                <img
                                  className=""
                                  src={ExplorIcon}
                                  alt=""
                                />
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default SearchModal;
